import { schoolDistricts } from "./schoolDistrictsData";
import { useParams } from "react-router-dom";
import LandingSection from "../components/LandingSection";
import Footer from "../components/Footer";
import publicAndCharterData from "./data/public-and-charter.json";

const SchoolDistrict = () => {
  const { districtSlug } = useParams();
  const district = schoolDistricts[districtSlug];

  if (!district) {
    return <div>District not found</div>;
  }

  // Map JSON schools that belong to this district.
  const matchedSchools = publicAndCharterData.sections.sheet1.filter(
    (school) => school.school_district.toLowerCase().startsWith(district.districtName.toLowerCase())
  );

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-blue-50 to-white">
      {/* Landing Section */}
      <LandingSection
        data={{
          imageName: "school.webp",
          title: `Schools in ${district.districtName}`,
          visible: true,
        }}
      />

      {/* Main Content */}
      <div className="mx-auto py-12 w-full">
        {/* Table */}
        {/* <div className="flex items-center justify-center">
          <div className="bg-white rounded-xl shadow-[0_4px_12px_0_rgba(1,76,178,0.3)] overflow-hidden w-[95%]">
            <div className="overflow-x-auto max-h-[1000px]">
              <table className="table-auto border-collapse border bg-white border-gray-300 w-full">
                <thead className="sticky top-0 z-10">
                  <tr>
                    <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider w-[35%]">
                      School Name
                    </th>
                    <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider w-[35%]">
                      Number of Students
                    </th>
                    <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider w-[30%]">
                      Grades
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white">
                  {district.schools.map((school, index) => (
                    <tr
                      key={index}
                      className="hover:bg-blue-50 transition-colors"
                    >
                      <td className="px-6 py-4 whitespace-nowrap text-center">
                        <div className="font-bold text-sm text-blue-900">
                          {school.schoolName}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-center font-bold text-blue-900">
                          {school.numberOfStudents}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-center font-bold text-blue-900">
                          {school.grades}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div> */}

        <div className="flex items-center justify-center my-12">
          <div className="bg-gray-300 z-10 rounded-xl shadow-[0_4px_12px_0_rgba(1,76,178,0.3)] overflow-hidden w-[95%]">
            <div className="overflow-x-auto max-h-[800px]">
              <table className="table-auto border-collapse border bg-white border-gray-300 w-full">
                <thead className="sticky top-0 z-10">
                  <tr>
                    <th className="border border-gray-300 bg-gray-300 px-4 py-2 text-center text-blue-900">
                      School Name
                    </th>
                    <th className="border border-gray-300 bg-gray-300 px-4 py-2 text-center text-blue-900">
                      School Type
                    </th>
                    <th className="border border-gray-300 bg-gray-300 px-4 py-2 text-center text-blue-900">
                      Grades
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {matchedSchools.map((school, index) => (
                    <tr key={index} className="hover:bg-gray-100">
                      <td className="border border-gray-300 px-4 py-2 text-center font-bold text-blue-900">
                        {school.website_link ? (
                          <a href={school.website_link.startsWith('http') ? school.website_link : `https://${school.website_link}`} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 underline">
                            {school.school_name}
                          </a>
                        ) : (
                          school.school_name
                        )}
                      </td>

                      <td className="border border-gray-300 px-4 py-2 text-center font-bold text-blue-900">
                        {school.school_type}
                      </td>
                      <td className="border border-gray-300 px-4 py-2 text-center font-bold text-blue-900">
                        {school.grades_served}
                      </td>
                    </tr>
                  ))}
                  {matchedSchools.length === 0 && (
                    <tr>
                      <td colSpan="3" className="border border-gray-300 px-4 py-4 text-center text-gray-500">
                        Loading...
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default SchoolDistrict;
